import { render, staticRenderFns } from "./propertyAreaUnitForm.vue?vue&type=template&id=1edadf68&%23default=true&"
import script from "./propertyAreaUnitForm.vue?vue&type=script&lang=js&"
export * from "./propertyAreaUnitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports